export default __webpack_public_path__ + "2eb19bf22a60724f5ea17756dbbca1b8.svg";